import React from 'react'
import * as  Styled from './styled';
import StarIcon from '@mui/icons-material/Star';
const Card = ({ imagePath, title, disc, price, oldPrice, type, numberRea, rate, brife }) => {
    return (
        <>
            <Styled.Card>
                {
                    type === "packages" && <Styled.Packages><Styled.PackText> حزمة </Styled.PackText> </Styled.Packages>
                }
                <Styled.ImageCard>
                    <Styled.Image
                        style={{
                            minWidth: 144,
                            height: 144,
                        }}
                        alt={""}
                        src={`${process.env.REACT_APP_BASE_URL}${imagePath}`}
                    />
                </Styled.ImageCard>
                <Styled.TitleCard>
                    {title}
                </Styled.TitleCard>
                <Styled.TitleDisc>{
                    disc ? disc :
                        <>
                            {brife}
                        </>
                }
                </Styled.TitleDisc>
                {/* {
                    type === "packages" ?
                        <Styled.SectionRate style={{ gap: '32px' }} >
                            <Styled.OldPrice style={{ textDecoration: 'line-through' }}>
                                {`${oldPrice} نقطة`}
                            </Styled.OldPrice>
                            <Styled.TitlePrice>
                                {`${price} نقطة`}
                            </Styled.TitlePrice>

                        </Styled.SectionRate>
                        : <Styled.SectionRate>
                            <StarIcon sx={{ color: '#F2C94C' }} />
                            <span style={{ fontWeight: '600', fontSize: '16px', color: '#333333' }} >
                                {rate}
                            </span>
                            <Styled.TitleDisc>
                                ({numberRea} تقييم)
                            </Styled.TitleDisc>
                        </Styled.SectionRate>
                } */}
            </Styled.Card>

        </>
    )
}

export default Card